import { render, staticRenderFns } from "./CardTarjaBlogueirinha.vue?vue&type=template&id=48bcfad6&scoped=true"
import script from "./CardTarjaBlogueirinha.vue?vue&type=script&lang=js"
export * from "./CardTarjaBlogueirinha.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaBlogueirinha.vue?vue&type=style&index=0&id=48bcfad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcfad6",
  null
  
)

export default component.exports